import React from 'react';
import './css/styles.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';

const App: React.FC = () => {
  return (
    <div className="app-wrapper">
      <Header />
      <Home />
      <Footer />
      <a href="#home" className="scrollup" aria-label="Back to top" title="Back to top">
        <i className="ri-arrow-up-line" aria-hidden="true" />
      </a>
    </div>
  );
};

export default App;
